import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

export default function ProtectedRoute({ children }) {
  const location = useLocation();
  const accessToken = useSelector((state) => state.auth?.accessToken);

  if (!accessToken) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  return children;
}
